import React from 'react';
// eslint-disable-next-line no-unused-vars
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import 'whatwg-fetch';
import DisplayPanel from '../reusableComponents/displayPanel';

const { $ } = window;

class FileViewForm extends React.Component {
  componentWillMount() {
    this.props.updatePanelState({
      error: '',
      heading: 'View Files',
      subHeading: '',
      path1: 'Files',
      path2: 'View',
    });
    this.state = { user: this.props.user };
  }

  componentDidMount() {
    this.getFiles();
  }

  render() {
    return (
      <section className='panel'>
        <header className='panel-heading'>
          <div className='panel-actions'>
            <a href='#' className='panel-action panel-action-toggle' data-panel-toggle></a>
          </div>

          <h2 className='panel-title'>Files</h2>
        </header>
        <div className='panel-body'>
          <table className='table table-bordered table-striped mb-none' id='datatable-default'>
            <thead>
              <tr>
                <th>Barcode</th>
                <th>Description</th>
                <th>Client Name</th>
                <th>Case Number</th>
                <th>Location</th>
                <th>Department Name</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {this.state.Files ? (
                this.state.Files.map(file => (
                  <tr key={file.id}>
                    <td> {file.barcode} </td>
                    <td> {file.description} </td>
                    <td> {file.clientName} </td>
                    <td> {file.caseNumber} </td>
                    <td>
                      {' '}
                      {file.Box ? (
                        <div>{file.Box.barcode}</div>
                      ) : file.inOffice ? (
                        <div>In Office</div>
                      ) : (
                        <div>{`In Transit - ${file.inTransit}`}</div>
                      )}{' '}
                    </td>
                    <td> {file.departmentName} </td>
                    <td>
                      {this.state.user.super ? (
                        <span>
                          <Link to={`/files/edit/${file.id}`}>Edit</Link>|{' '}
                          <Link to={`/files/archive/${file.id}`}>Archive</Link> |{' '}
                        </span>
                      ) : null}
                      <Link to={`/files/details/${file.id}`}>Details</Link>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>Loading..</td>
                  <td>Loading..</td>
                  <td>Loading..</td>
                  <td>Loading..</td>
                  <td>Loading..</td>
                  <td>Loading..</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    );
  }

  getFiles() {
    const self = this;
    const token = localStorage.getItem('jwt');
    const head = new Headers();
    head.append('Content-Type', 'application/json');
    head.append('Authorization', token);
    fetch('/api/Files/getAll', { method: 'GET', headers: head })
      .then(response => {
        if (response.status === 401) {
          this.setState({ token: '' });
          localStorage.removeItem('jwt');
          window.location = '/login';
        }
        if (response.status !== 200) {
          self.props.updatePanelState({
            error: `There was an issue getting Files. Status Code: ${response.status}`,
          });
          return;
        }
        response.json().then(data => {
          if (data.success === false) {
            self.props.updatePanelState({ error: data.message });
            return;
          }
          self.setState({ Files: data.data });
          $('#datatable-default').dataTable();
        });
      })
      .catch(err => {
        self.props.updatePanelState({ error: err.message });
      });
  }
}

export default class FileViewPage extends React.Component {
  render() {
    return (
      <DisplayPanel>
        <FileViewForm user={this.props.user} />
      </DisplayPanel>
    );
  }
}
